import styled from '@emotion/styled';

import { withConfig } from 'src/withConfig';





/* SingleScoreVariantType.PRIMARY */

export const SingleScoreWrapper = withConfig(theme => styled('div', { label: 'SingleScoreWrapper' })`

    align-items: center;

    background-color: ${theme.star.eventRow.bgColorTertiary};

    color: ${theme.star.eventRow.txtColorTertiary};

    display: flex;

    flex-flow: column nowrap;

    flex: 0 0 26px;

    justify-content: center;

    padding: 0 4px;

    text-align: center;

    @media ${theme.star.mediaQuery.desktop} {

        flex-flow: row nowrap;

        flex: 0 0 65px;

        padding: 0 8px;

    }

`);



export const SingleScoreItem = withConfig(theme => styled('div', { label: 'SingleScoreItem' })`

    font-size: ${theme.star.fontSize.small};

    line-height: 1.3334;

    font-weight: ${theme.star.fontWeight.medium};

    &:first-of-type {

        margin-bottom: 8px;

    }

    @media ${theme.star.mediaQuery.desktop} {

        &:first-of-type {

            margin-bottom: 0;

            &::after {

                content: '-';

            }

        }

    }

`);

/* end of SingleScoreVariantType.PRIMARY */



/*

--------------------------------------------

--------------------------------------------

--------------------------------------------

*/



/* SingleScoreVariantType.SECONDARY */

export const SingleScoreBox = withConfig(theme => styled('div', { label: 'SingleScoreBox' })`

    align-items: center;

    background-color: ${theme.star.score.color.bgPrimary};

    color: ${theme.star.score.color.txtPrimary};

    display: flex;

    flex-flow: column nowrap;

    flex: 0 0 36px;

    font-size: ${theme.star.score.typography.fontSizePrimary};

    font-style: normal;

    font-weight: ${theme.star.score.typography.fontWeight};

    justify-content: center;

    line-height: ${theme.star.score.typography.lineHeightPrimary};

    border-radius: ${theme.star.score.radius};

    padding: ${theme.star.score.padding};

    text-align: center;

`);



export const SingleScoreBoxItem = styled('i', { label: 'SingleScoreBoxItem' })`

    align-items: center;

    display: flex;

    flex: 1 1 auto;

    font-style: normal;

    justify-content: center;

    width: 100%;

`;

/* end of SingleScoreVariantType.SECONDARY */





/* SingleScoreVariantType.TERTIARY */

export const SingleScoreWrapperTertiary = withConfig(theme => styled('div', { label: 'SingleScoreWrapperTertiary' })`

    align-items: center;

    background-color: ${theme.star.unified.score.color.bgPrimary};

    color: ${theme.star.unified.score.color.txtPrimary};

    display: flex;

    flex-flow: column nowrap;

    font-size: ${theme.star.unified.score.typography.fontSizePrimary};

    font-style: normal;

    font-weight: ${theme.star.unified.score.typography.fontWeight};

    justify-content: center;

    line-height: ${theme.star.unified.score.typography.lineHeightPrimary};

    text-align: center;

    width: 14px;

`);



export const SingleScoreItemTertiary = styled('i', { label: 'SingleScoreItemTertiary' })`

    align-items: center;

    display: flex;

    flex: 1 1 auto;

    font-style: normal;

    justify-content: center;

    width: 100%;

`;

/* end of SingleScoreVariantType.TERTIARY */